module.exports = __webpack_public_path__ + "static/media/matching_tablet.b1e1748e.svg";